<template>
    <footer class="footer"
            :class="{[`footer-${type}`]: type}"
            :data-background-color="backgroundColor">
        <div class="container">
          <nav>
            <a class="navbar-brand" style=" -webkit-transition: all 5.5s ease;">
              Chad Ashe
            </a>
          </nav>
<!--            <nav>-->
<!--                <ul>-->
<!--                    <li>-->
<!--                        <a href="https://www.creative-tim.com">-->
<!--                            Creative Tim-->
<!--                        </a>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                        <a href="https:///presentation.creative-tim.com">-->
<!--                            About Us-->
<!--                        </a>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                        <a href="https:///blog.creative-tim.com">-->
<!--                            Blog-->
<!--                        </a>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                        <a href="https://www.creative-tim.com/license">-->
<!--                            License-->
<!--                        </a>-->
<!--                    </li>-->
<!--                </ul>-->
<!--            </nav>-->
<!--            <div class="copyright">-->
<!--                &copy; {{year}}, Designed by-->
<!--                <a href="https:///www.invisionapp.com" target="_blank">Invision</a>. Coded by-->
<!--                <a href="https://github.com/cristijora" target="_blank">Cristi Jora</a> and-->
<!--                <a href="https://www.creative-tim.com" target="_blank">Creative Tim</a>.-->
<!--            </div>-->
        </div>
    </footer>
</template>
<script>
  import Navbar from "@/components/Navbar/Navbar";
  export default {
    components: {Navbar},
    props: {
      backgroundColor: String,
      type: String
    },
    data(){
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>
<style>
</style>
